import { useLocation, useParams } from 'react-router-dom';

import NotificationsOverview from '../../features/notifications/layouts/overview';
import CreateTemplateForm from '../../features/notifications/forms/create';
import EditTemplateForm from '../../features/notifications/forms/edit';

// TSS vite/01 §"Pages are thin". Servicios → Notificaciones (plantillas).
export default function NotificationsPage() {
    const { code } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateTemplateForm />;
    if (code && pathname.endsWith('/edit')) return <EditTemplateForm code={code} />;
    return <NotificationsOverview />;
}
